import React from "react"
import {Button, Stack} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {useSelector} from "react-redux";
import PaymentHeaders from "./PaymentHeaders";
import BackButton from "../Common/BackButton";
import {ServiceCardType} from "../Types";
import {useTranslation} from "react-i18next";
import {RootState} from "../../../Redux";

interface PaymentMethodSelectionProps {
    serviceCard: ServiceCardType
    setPayWithCard: (payWithCard: boolean) => void
    onBack: () => void
}

const PaymentMethodSelection: React.FC<PaymentMethodSelectionProps> = ({ serviceCard, setPayWithCard, onBack }) => {
    const { t } = useTranslation()
    const paymentTerminalApiUrl = useSelector((state: RootState) => state.ui.settings.selfService.paymentTerminalApiUrl)
    const nexiTerminalId = useSelector((state: RootState) => state.ui.settings.selfService.nexiTerminalId)
    const hasCardTerminal = !!(paymentTerminalApiUrl || nexiTerminalId)

    return (
        <Grid container wrap="nowrap" direction="column" justifyContent="space-between" alignItems="center" spacing={2} className="pageMainContainer">
            <Grid className="pageMainHeader">
                <PaymentHeaders serviceCard={serviceCard} />
            </Grid>
            <Grid size="grow">
                <Stack direction="column" spacing={4} maxWidth='33%'>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => setPayWithCard(false)}
                    >{t('selfService.payOnline')}</Button>
                    {hasCardTerminal &&
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => setPayWithCard(true)}
                        >{t('selfService.payWithCard')}</Button>
                    }
                </Stack>
            </Grid>
            <Grid className="footerButtons">
                <Grid container wrap="nowrap" spacing={4} justifyContent="space-between" alignItems="end">
                    <BackButton onBack={onBack} />
                </Grid>
            </Grid>
        </Grid>
    )
}

export default PaymentMethodSelection
